import { render, staticRenderFns } from "./Particulars.vue?vue&type=template&id=5ab93be8&scoped=true"
import script from "./Particulars.vue?vue&type=script&lang=js"
export * from "./Particulars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab93be8",
  null
  
)

export default component.exports